import MyProfileImage from 'src/components/filmwebid/MyProfileImage';
import LoginSvg from 'src/components/svg/LoginSvg';
import theme from 'src/components/themes/DefaultTheme';
import { UserContextType, useUserContext } from 'src/lib/contexts/UserContext';
import styled from "src/lib/styles/css";
//#region [Styles]
const SLogin = styled.div`
	--portrait-size: 27px;

	cursor: pointer;
	height: 100%;
	padding: 0 5px;
	@media (min-width: 550px) {
		padding: 0 15px;
        margin: 0 0 0 auto;
	}
`;

const SButton = styled.button`
	height: 100%;
	cursor: pointer;
	align-items: center;
	justify-content: center;
	background: transparent;
	border: none;
`;

const SLoginText = styled.div`
	font-size: 10px;
	color: ${theme.textColor};
	line-height: 12px;
	margin-top: 6px;
	white-space: nowrap;
`;

const SLoginSvg = styled(LoginSvg)`
	fill: ${theme.textColor};
	height: 20px;
	margin: 0 auto;
`;
//#endregion

//#region [Props]
type LoginButtonProps = {
	className?: string;
	onClickIfAuthenticated: () => void;
};
//#endregion

//#region [Component]
export default function LoginButton({ className, onClickIfAuthenticated }: LoginButtonProps) {
	const authContext = useUserContext();

	return <SLogin className={className}>
		<SButton onClick={() => loginClicked(authContext, onClickIfAuthenticated)}>
			{authContext.isAuthenticated ? <MyProfileImage /> : <SLoginSvg />}
			<SLoginText>
				{authContext.isAuthenticated ? LOGGED_IN_TEXT : NOT_LOGGED_IN_TEXT}
			</SLoginText>
		</SButton>

	</SLogin>;
}
//#endregion

const NOT_LOGGED_IN_TEXT = "Logg inn";
const LOGGED_IN_TEXT = "Min side";

//#region [Other]
function loginClicked(authContext: UserContextType, onClickIfAuthenticated: () => void) {
	if (!authContext.isAuthenticated) {
		window?.dataLayer?.push({
			'event': 'watchlist',
			'eventCategory': 'watchlist',
			'eventAction': "login_click",
			'eventLabel': "start_login"
		});
		authContext.doLogin();
	} else {
		onClickIfAuthenticated();
	}
}
//#endregion